import {Component, OnInit} from '@angular/core';
import {BaseComponent} from '../../shared/base/base.component';
import {Store} from '@ngrx/store';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {forkJoin} from 'rxjs';
import {GlobalService} from '../../shared/services/global.service';
import {AppState} from '../../store/app.reducer';
import {SetBreadcrumb} from '../../fixed-toolbar/fixed-toolbar.action';

@Component({
    selector: 'app-projects',
    templateUrl: './projects.component.html',
    styleUrls: ['./projects.component.css']
})
export class ProjectsComponent extends BaseComponent implements OnInit {

    constructor(
        protected store: Store<AppState>,
        protected gs: GlobalService,
        protected router: Router,
        protected route: ActivatedRoute,
        protected translate: TranslateService
    ) {
        super(store, gs);
    }

    ngOnInit(): void {
        this.subs.sink = forkJoin([
            this.translate.get('projects.title_m'),
        ]).subscribe(result => {
            this.store.dispatch(new SetBreadcrumb([
                {label: result[0], routerLink: '/projects'},
            ]));
        });
    }
}
